module.exports = __webpack_public_path__ + "img/not-checked-traning-icon.9b859948.svg";